import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { isArtBoardHalted } from '@store/reducers/artboard'
import type { AppState } from '@store/types'
import { useSelector } from 'react-redux'

import { useArtboardMode } from '@/hooks'
import usePrintRender from '../../../../../hooks/usePrintRender'

export const useHeaderToolbar = () => {
  const { isPrinting } = usePrintRender()

  // The controls go while saving is down or the activity history is open.
  // The assistant's turn leaves them in place: Publish answers it with a
  // toast of its own (OCT-4826).
  const isDisabled = useSelector<AppState, boolean>(({ artboard }) =>
    isArtBoardHalted(artboard)
  )

  const isReadOnly = useSelector(
    migrationProjectSelector.getProjectLegacyAccessTypeIsReadOnly
  )

  const isTemplate = useSelector(migrationProjectSelector.getProjectIsTemplate)
  const { seoMode } = useArtboardMode()

  const unsaved = useSelector(
    migrationProjectSelector.getProjectHasChangesAndNotSaved
  )

  const trial = useSelector(migrationProjectSelector.getProjectIsTrial)

  const showSaveProject = (unsaved || trial) && !seoMode

  return {
    isPrinting,
    isDisabled,
    showSaveProject,
    isReadOnly,
    seoMode,
    isTemplate,
  }
}
